<template>
  <div>
    <div class="vd-gl-search-form">
      <a-form layout="inline">
        <a-form-item>
          <a-tooltip title="公众号名称">
            <a-input
              :allow-clear="true"
              placeholder="请输入公众号"
              v-model="searchForm.blogName"
            />
          </a-tooltip>
        </a-form-item>
        <a-form-item>
          <a-tooltip title="所属地区">
            <a-cascader
              style="width: 216px"
              :options="areaTree"
              v-model="searchForm.areaPath"
              :field-names="{
                label: 'name',
                value: 'id',
                children: 'children',
              }"
              placeholder="公众号所属地区"
              :change-on-select="true"
            />
          </a-tooltip>
        </a-form-item>
        <a-form-item>
          <a-tooltip title="项目">
            <a-select
              style="width: 116px"
              allowClear
              v-model="searchForm.category"
              placeholder="公众号项目"
            >
              <template v-for="item in subList">
                <a-select-option :key="item.id">
                  {{ item.nickname }}
                </a-select-option>
              </template>
            </a-select>
          </a-tooltip>
        </a-form-item>
        <a-form-item :wrapper-col="wrapperCol">
          <a-button @click="searchInfo"> 搜索</a-button>
        </a-form-item>
        <a-form-item> </a-form-item>
      </a-form>
    </div>
    <div class="vd-gl-content">
      <!-- 内容主体 -->
      <a-row type="flex" class="vd-table-head">
        <a-col flex="auto" class="vd-table-name"> 公众号列表</a-col>
        <a-col class="vd-table-tool">
          <a-button @click="auth"> 接入公众号 </a-button>
          <!-- <a-divider type="vertical" />
          <a-icon class="common-icon" type="reload"></a-icon> -->
        </a-col>
      </a-row>
      <a-table
        :data-source="list"
        :pagination="pagination"
        :loading="loading"
        row-key="id"
        size="small"
      >
        <a-table-column title="ID" data-index="id" />
        <a-table-column title="头像" data-index="head_img">
          <template slot-scope="item">
            <a-avatar slot="avatar" :src="item" size="large" />
          </template>
        </a-table-column>
        <a-table-column title="名称" data-index="name" />
        <a-table-column title="类型" data-index="type">
          <template slot-scope="item">
            {{ typeList[item]['name'] }}
          </template>
        </a-table-column>
        <a-table-column title="归属地" data-index="a_name" />
        <a-table-column title="项目" data-index="c_name" />
        <a-table-column title="操作" align="center">
          <template slot-scope="record">
            <a-tooltip title="设置">
              <a-icon
                class="common-icon"
                type="setting"
                @click="setting(record)"
              />
            </a-tooltip>
            <!-- /blog/sync -->
            <a-tooltip title="同步数据">
              <a-icon
                class="common-icon"
                type="sync"
                @click="syncData(record)"
              />
            </a-tooltip>
            <a-tooltip title="详情">
              <a-icon
                class="common-icon"
                type="small-dash"
                @click="detail('/blog/detail', record.id)"
              />
            </a-tooltip>
          </template>
        </a-table-column>
      </a-table>
      <!-- 设置框 -->
      <a-modal
        ok-text="确定"
        cancel-text="取消"
        title="修改公众号"
        @cancel="cancel"
        @ok="confirm"
        :visible="visible"
      >
        <a-form-model
          ref="ruleForm"
          layout="horizontal"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item label="公众号类型" prop="type">
            <a-select
              style="width: 116px"
              allowClear
              v-model="form.type"
              placeholder="公众号类型"
            >
              <a-select-option
                v-for="item in typeList"
                :value="item.value"
                :key="item.value"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="所属地区" prop="areaPath">
            <a-cascader
              style="width: 216px"
              :options="areaTree"
              v-model="form.areaPath"
              :field-names="{
                label: 'name',
                value: 'id',
                children: 'children',
              }"
              placeholder="公众号所属地区"
              :change-on-select="true"
            />
          </a-form-model-item>
          <a-form-model-item label="项目" prop="category">
            <a-select
              style="width: 116px"
              allowClear
              v-model="form.category"
              placeholder="公众号项目"
            >
              <template v-for="item in subList">
                <a-select-option :key="item.id">
                  {{ item.nickname }}
                </a-select-option>
              </template>
            </a-select>
          </a-form-model-item>
          不存在的用户请联系管理员添加

          <a-form-model-item label="运营者">
            <a-select
              style="width: 150px"
              v-model="agentId"
              @search="dataChange"
              show-search
              placeholder="运营者"
              :show-arrow="false"
              :filter-option="false"
              allowClear
            >
              <a-select-option
                v-for="item in adminList"
                :key="item.id"
                :value="item.id"
              >
                {{ item.nickname }} - {{ item.area_name }}
              </a-select-option>
            </a-select>
            <a-button style="margin-left:16px" @click="bandAgent">
              添加
            </a-button>
          </a-form-model-item>
          <a-form-model-item :wrapperCol="{ span: 18, offset: 2 }">
            <template v-for="item in agentList">
              <a-tag :key="item.id" closable @close="removeAgent(item.id)">
                {{ item.username }} - {{ item.area_name }}
              </a-tag>
            </template>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { admin_by_usernma, get_sub } from '@/api'
import {
  get_blog_list,
  get_auth_link,
  modify_auth_blog,
  modify,
  sync_data,
  agent_list,
  band_agent,
  remove_agent,
} from '@/api/blog'
import { get_area_tree } from '@/api/auth'

export default {
  name: 'Setting',
  data() {
    return {
      loading: false,
      form: {
        id: undefined,
        areaPath: undefined,
        type: undefined,
        category: undefined,
      },
      typeList: [
        { name: '服务号', value: 0 },
        { name: '品牌号', value: 1 },
        { name: '项目', value: 2 },
      ],
      rules: {
        areaPath: [
          { required: true, message: '请填写活动名称', trigger: 'blur' },
        ],
        category: [
          { required: true, message: '请填写活动名称', trigger: 'blur' },
        ],
      },
      subList: [],
      areaTree: [],
      visible: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      list: [],
      adminList: [],
      agentId: undefined,
      agentList: [],
      searchForm: {
        blogName: undefined,
        areaPath: undefined,
        category: undefined,
      },
      code: '',
      login_qq: undefined,
      pageLoading: false,
      pagination: {
        current: 1,
        total: 0,
        pageSize: 15,
        hideOnSinglePage: true,
        showTotal: (total) => `总共 ${total} 条`,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
    }
  },
  created() {
    if (!this.$HelperUtil.isEmpty(this.$route.query)) {
      // 页面loading
      this.blogInfo(this.$route.query.auth_code)
    }

    this.getData()

    get_sub('item_type').then((res) => {
      if (res.code === 1) {
        this.subList = res.list
      }
    })
    get_area_tree().then((res) => {
      if (res.code === 1) {
        this.areaTree = res.areaTree
      }
    })
  },
  methods: {
    // 获取数据
    getData() {
      this.loading = true
      get_blog_list({
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
        blogName: this.searchForm.blogName,
        areaPath: this.searchForm.areaPath,
        category: this.searchForm.category,
      }).then((res) => {
        this.loading = false
        if (res.code === 1) {
          this.list = res.list
          this.pagination.total = res.total
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    detail(key, id) {
      this.$router.push({ path: key, query: { id: id } })
    },
    setting(record) {
      this.visible = true
      this.form.id = record.id
      this.form.category = record.category
      this.form.type = record.type
      this.form.areaPath = record.area_path
      this.adminList = []
      this.agentList = []
      this.agentId = undefined
      this.getagentList(record.id)
    },
    cancel() {
      this.visible = false
      this.form.id = undefined
      this.form.category = undefined
      this.form.type = undefined
      this.form.areaPath = []
      this.adminList = []
      this.agentList = []
      this.agentId = undefined
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.visible = false
          modify({
            id: this.form.id,
            areaPath: this.form.areaPath,
            category: this.form.category,
            type: this.form.type,
          }).then((res) => {
            if (res.code === 1) {
              this.$message.success(res.msg)
              this.getData()
            } else {
              this.$message.warning(res.msg)
            }
          })
        }
      })
    },
    // 搜索按钮
    searchInfo() {
      this.pagination.current = 1
      this.pagination.total = 0
      this.getData()
    },
    // 接入数据
    auth() {
      get_auth_link().then((res) => {
        if (res.code === 1) {
          window.location.href = res.auth_url
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    blogInfo(auth_code) {
      const modal = this.$info({
        title: '处理数据中~',
      })

      modify_auth_blog({
        auth_code: auth_code,
      }).then((res) => {
        modal.destroy()
        this.blogDone(res.code, res.msg)
      })
    },
    blogDone(code, message) {
      let secondsToGo = 3
      if (code === 0) {
        const modal = this.$warning({
          title: message,
          content: ` ${secondsToGo} 秒后自动关闭.`,
        })
        const interval = setInterval(() => {
          secondsToGo -= 1
          modal.update({
            content: ` ${secondsToGo} 秒后自动关闭.`,
          })
        }, 1000)
        setTimeout(() => {
          clearInterval(interval)
          modal.destroy()
        }, secondsToGo * 1000)
      } else {
        const modal = this.$success({
          title: message,
          content: ` ${secondsToGo} 秒后自动关闭.`,
        })
        const interval = setInterval(() => {
          secondsToGo -= 1
          modal.update({
            content: ` ${secondsToGo} 秒后自动关闭.`,
          })
        }, 1000)
        setTimeout(() => {
          clearInterval(interval)
          modal.destroy()
        }, secondsToGo * 1000)
      }
    },
    syncData({ id }) {
      console.log(id)
      sync_data({}).then((res) => {
        console.log(res)
      })
    },

    dataChange(val) {
      if (!this.$HelperUtil.isEmpty(val)) {
        admin_by_usernma({ username: val }).then((res) => {
          console.log(res)
          this.adminList = res.list
        })
      }
    },
    bandAgent() {
      band_agent({ blogId: this.form.id, uid: this.agentId }).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.msg)
          this.getagentList()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    getagentList() {
      agent_list({ id: this.form.id }).then((res) => {
        if (res.code === 1) {
          this.agentList = res.list
          this.$forceUpdate()
        }
      })
    },
    removeAgent(id) {
      // 移除id
      remove_agent({ blogId: this.form.id, uid: id }).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.msg)
          this.getagentList()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
  },
}
</script>

<style scoped></style>
